import React from 'react';
import classNames from 'classnames';
import Breadcrumbs from '../Breadcrumbs';
import { useTranslation } from 'react-i18next';
import { BreadcrumbsLink } from '../Breadcrumbs/Breadcrumbs.component';

import './BusinessesTitle.styles.scss';
import './BusinessesTitle.styles.responsive.scss';

type BusinessesTitleProps = {
  className?: string;
  title: string;
  ariaLabel?: string;
  breadcrumbsLinks?: BreadcrumbsLink[];
  currentPage?: string;
  withPage?: boolean;
};

const BusinessesTitle: React.FC<BusinessesTitleProps> = (props) => {
  const {
    children,
    className,
    title,
    breadcrumbsLinks,
    currentPage,
    ariaLabel,
    withPage = true,
  } = props;

  const classes = classNames('businesses-title', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      {breadcrumbsLinks && <Breadcrumbs links={breadcrumbsLinks} />}

      <h1 aria-label={ariaLabel || title}>{title}</h1>

      {withPage && (
        <p className="pagination-info">
          {t('page', { page: currentPage || 1 })}
        </p>
      )}

      {children}
    </div>
  );
};

export default BusinessesTitle;
